// /inbox — «Входящие» (032: T030; FR-001, FR-002, FR-004; ASG-HIST-03): лента уведомлений по дням,
// вкладки, «Непрочитанные», карточка выбранного уведомления. Пункт меню, колокольчик, нижняя
// навигация и G I ведут сюда. Условия — в адресе: /inbox?n=<id> — выбранная строка (ссылка
// и «Назад» работают), tab — вкладка, unread — «Непрочитанные». Своего права у раздела нет: свои
// уведомления есть у каждого в сеансе, и у сеанса по ссылке тоже.
import { createFileRoute } from '@tanstack/react-router';
import { InboxPage } from '../../features/inbox/InboxPage.tsx';
import { parseInboxSearch } from '../../features/inbox/data.ts';
import { useInboxNavigation } from '../../features/inbox/navigation.ts';

export const Route = createFileRoute('/_app/inbox')({
  validateSearch: parseInboxSearch,
  staticData: { crumb: 'Входящие' },
  component: InboxRoute,
});

function InboxRoute() {
  const search = Route.useSearch();
  const onSearchChange = useInboxNavigation(search);
  return <InboxPage search={search} onSearchChange={onSearchChange} />;
}
